import { useState } from "react";

import AIDiscoverySection from "./AIDiscoverySection";
import CTASection from "./CTASection";
import FeatureEditorial from "./FeatureEditorial";
import HeroSection from "./HeroSection";
import LeadModal from "./LeadModal";
import ReportArchitectureGrid from "./ReportArchitectureGrid";

const LandingPage = () => {
  const [showLeadModal, setShowLeadModal] = useState(false);

  return (
    <>
      <HeroSection />
      <ReportArchitectureGrid />
      <FeatureEditorial />
      <AIDiscoverySection />
      <CTASection onRequestDemo={() => setShowLeadModal(true)} />
      <LeadModal open={showLeadModal} onOpenChange={setShowLeadModal} />
    </>
  );
};

export default LandingPage;
